<template>
  <div id="nps-feature-analytics">
    <vx-card class="nps-feature-analytics__filters-card mb-base">
      <div class="nps-feature-analytics__filters-grid">
        <div class="nps-feature-analytics__field">
          <span class="text-sm nps-feature-analytics__label">Intervalo</span>
          <div class="nps-feature-analytics__date-row">
            <flat-pickr
              ref="initial"
              v-model="initial_date"
              class="nps-feature-analytics__date-input"
              placeholder="Intervalo inicial"
              :config="initialConfigdateTimePicker"
            />
            <flat-pickr
              ref="final"
              v-model="finish_date"
              class="nps-feature-analytics__date-input"
              placeholder="Intervalo final"
              :config="finalConfigdateTimePicker"
            />
          </div>
        </div>

        <div class="nps-feature-analytics__field">
          <span class="text-sm nps-feature-analytics__label">Filtros</span>
          <div class="nps-feature-analytics__checkbox-grid">
            <!-- <vs-checkbox v-model="showTenantInput">
              <small>Nome da Plataforma</small>
            </vs-checkbox> -->
            <vs-checkbox v-model="onlyActivesTenants">
              <small>Apenas Tenants Ativos</small>
            </vs-checkbox>
          </div>
        </div>

        <div class="nps-feature-analytics__actions">
          <vs-button @click="filterDashboard" :disabled="buttonDisabled || !canFilter">
            Filtrar
          </vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-base">
      <!-- <div v-if="showTenantInput" class="nps-feature-analytics__tenant-input-card">
        <h3 class="nps-feature-analytics__tenant-title">Busca por Nome da Plataforma</h3>
        <p class="nps-feature-analytics__tenant-text">
          Digite o início do nome da plataforma para localizar tenants específicos no analytics.
        </p>

        <label for="nps-feature-analytics-tenant-input" class="nps-feature-analytics__tenant-label">
          Nome da Plataforma
        </label>

        <vs-input
          id="nps-feature-analytics-tenant-input"
          v-model="tenantInput"
          placeholder="Ex: drogaria, farmacia, clinica..."
          class="w-full"
        />

        <p v-if="tenantInput && !isTenantInputValid" class="nps-feature-analytics__error">
          Nome inválido. Informe pelo menos 3 caracteres que correspondam a uma plataforma existente.
        </p>
      </div> -->

      <div class="nps-feature-analytics__tenant-list">
        <tenants-slim-list
          checkbox
          :selecteds="hostnames"
          :only-actives="onlyActivesTenants"
          @selectedTenant="hostnamesChanged"
        />
      </div>
    </vx-card>

    <vx-card class="nps-feature-analytics__iframe-card">
      <iframe
        v-if="dashboardUrl"
        ref="iframe"
        scrolling="no"
        allowtransparency
        :src="dashboardUrl"
        class="nps-feature-analytics__iframe"
      ></iframe>
    </vx-card>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import { mapGetters } from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import TenantsSlimList from '@/views/Tenants/TenantsSlimList.vue';

export default {
  name: 'dashboard-nps-feature-analytics',
  components: {
    flatPickr,
    TenantsSlimList,
  },
  data() {
    return {
      hostnames: [],
      initial_date: null,
      finish_date: null,
      buttonDisabled: false,
      showTenantInput: false,
      tenantInput: null,
      onlyActivesTenants: true,
      dashboardUrl: null,
      dashboardIds: {
        development: 90,
        testing: 92,
        production: 123,
      },
      initialConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        onChange: this.calendarChange,
      },
      finalConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        minDate: null,
        maxDate: new Date(),
        dateFormat: 'd/m/Y',
      },
      payload: {
        resource: {},
        params: {},
        exp: Math.round(Date.now() / 1000) + (1024 * 920),
      },
    };
  },
  computed: {
    ...mapGetters(['token', 'tenants']),
    currentEnvironment() {
      const href = window.location.href || '';
      if (href.includes('localhost')) {
        return 'development';
      }

      if (href.includes('backoffice-testing')) {
        return 'testing';
      }

      return 'production';
    },
    currentDashboardId() {
      return this.dashboardIds[this.currentEnvironment] || 90;
    },
    isTenantInputValid() {
      if (!this.tenantInput || this.tenantInput.length < 3) {
        return false;
      }

      return this.tenants.some((tenant) => {
        const prefix = tenant && tenant.fqdn ? tenant.fqdn.split('.')[0].toLowerCase() : '';
        return prefix.startsWith(this.tenantInput.toLowerCase());
      });
    },
    canFilter() {
      if (this.showTenantInput) {
        return this.isTenantInputValid;
      }

      return this.hostnames.length > 0;
    },
    initialDate() {
      return this.stringToDate(this.initial_date, 'dd/MM/yyyy', '/');
    },
    finishDate() {
      const finishedDate = this.stringToDate(this.finish_date, 'dd/MM/yyyy', '/');
      finishedDate.setHours(23, 59, 59, 9998);
      return finishedDate;
    },
  },
  watch: {
    hostnames(value) {
      this.buttonDisabled = !value.length && !this.showTenantInput;
    },
    showTenantInput(value) {
      this.hostnames = [];
      if (!value) {
        this.tenantInput = null;
      }
    },
    tenantInput(value) {
      if (!value) {
        this.hostnames = [];
        return;
      }

      const formatted = value.toLowerCase().normalize('NFD').replace(
        /[\u0300-\u036f]/g, ''
      ).replace(
        /[^a-z0-9\s-]/g, ''
      ).replace(/\s+/g, '-').replace(/-+/g, '-');

      if (value !== formatted) {
        this.tenantInput = formatted;
        return;
      }

      if (this.showTenantInput) {
        const filtered = this.tenants.filter((tenant) => {
          const prefix = tenant && tenant.fqdn ? tenant.fqdn.split('.')[0].toLowerCase() : '';
          return prefix.startsWith(formatted);
        });

        this.hostnames = filtered.map((tenant) => tenant.id);
      }
    },
  },
  methods: {
    stringToDate(date, format, delimiter) {
      const formatLowerCase = format.toLowerCase();
      const formatItems = formatLowerCase.split(delimiter);
      const dateItems = date.split(delimiter);
      const dayIndex = formatItems.indexOf('dd');
      const monthIndex = formatItems.indexOf('mm');
      const yearIndex = formatItems.indexOf('yyyy');
      const month = parseInt(dateItems[monthIndex], 10) - 1;

      return new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    },
    verify() {
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor');

      if (!permissions && !twoFactor) {
        this.$router.push('/user-settings');
      } else if (!permissions && twoFactor) {
        this.$router.push('/two-factor');
      }
    },
    calendarChange(selectedDates) {
      const start = selectedDates[0];
      if (!start || !this.$refs.final || !this.$refs.final.fp) {
        return;
      }

      const fp = this.$refs.final.fp;
      fp.set('minDate', start);
      fp.set('maxDate', new Date());
    },
    hostnamesChanged(selected) {
      this.hostnames = selected;
    },
    filterDashboard() {
      this.buttonDisabled = true;
      setTimeout(() => {
        this.buttonDisabled = false;
      }, 2000);

      this.loadMetabase();
    },
    loadMetabase() {
      this.payload.params = this.updateArgs();
      this.payload.resource = { dashboard: this.currentDashboardId };
      const token = jwt.sign(
        this.payload,
        process.env.VUE_APP_METABASE_SECRET_KEY,
        '',
        ''
      );

      this.dashboardUrl = process.env.VUE_APP_METABASE_SITE_URL + '/embed/dashboard/' + token + '#bordered=false&titled=false';
    },
    updateArgs() {
      return {
        data_final: this.finishDate,
        data_inicial: this.initialDate,
        tenant_ids: !this.showTenantInput ? this.hostnames.toString() : '0',
        tenant: this.showTenantInput && this.tenantInput ? this.tenantInput : null,
      };
    },
  },
  async beforeMount() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const todayDay = String(today.getDate()).padStart(2, '0');

    if (!this.tenants.length) {
      await this.$store.dispatch('getAllTenants', { token: this.token });
    }

    this.initial_date = todayDay + '/' + mm + '/' + yyyy;
    this.finish_date = todayDay + '/' + mm + '/' + yyyy;
    this.hostnames = this.tenants.length > 0 ? [this.tenants[0].id] : [];

    this.loadMetabase();
  },
  mounted() {
    this.verify();
  },
};
</script>

<style lang="scss">
@import '~flatpickr/dist/flatpickr.css';

#nps-feature-analytics {
  .nps-feature-analytics__filters-card,
  .nps-feature-analytics__iframe-card {
    border-radius: 20px;
    border: none;
    box-shadow: 0 4px 20px 0 rgba(15, 23, 42, 0.06);
    overflow: visible;
  }

  .nps-feature-analytics__filters-grid {
    display: grid;
    grid-template-columns: minmax(280px, 2fr) minmax(240px, 1.2fr) auto;
    gap: 1rem;
    align-items: end;
  }

  .nps-feature-analytics__field {
    min-width: 0;
  }

  .nps-feature-analytics__label,
  .nps-feature-analytics__tenant-label {
    display: inline-block;
    margin-bottom: 0.45rem;
    color: #64748b;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .nps-feature-analytics__date-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem;
  }

  .nps-feature-analytics__date-input {
    width: 100%;
  }

  .nps-feature-analytics__date-input ::v-deep input {
    width: 100%;
    min-height: 44px;
    padding: 0.75rem 0.95rem;
    border: 1px solid #d7dde5;
    border-radius: 12px;
    color: #0f172a;
    background: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .nps-feature-analytics__date-input ::v-deep input:focus {
    border-color: #3893fa;
    box-shadow: 0 0 0 3px rgba(56, 147, 250, 0.16);
  }

  .nps-feature-analytics__checkbox-grid {
    display: grid;
    gap: 0.65rem;
    padding-top: 0.2rem;
  }

  .nps-feature-analytics__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .nps-feature-analytics__tenant-input-card {
    padding: 0.25rem;
  }

  .nps-feature-analytics__tenant-title {
    margin: 0 0 0.5rem;
    color: #1e293b;
    font-size: 1.05rem;
    font-weight: 700;
  }

  .nps-feature-analytics__tenant-text {
    margin-bottom: 1rem;
    color: #64748b;
    font-size: 0.92rem;
    line-height: 1.55;
  }

  .nps-feature-analytics__error {
    margin-top: 0.5rem;
    color: #ef4444;
    font-size: 0.76rem;
  }

  .nps-feature-analytics__iframe {
    width: 100%;
    min-height: 4200px;
    border: none;
    border-radius: 18px;
    background: #fff;
  }

  .nps-feature-analytics__tenant-list ::v-deep .vx-card,
  .nps-feature-analytics__tenant-list ::v-deep .vs-con-table,
  .nps-feature-analytics__tenant-list ::v-deep .con-vs-card {
    box-shadow: none;
  }

  @media (max-width: 1100px) {
    .nps-feature-analytics__filters-grid {
      grid-template-columns: 1fr;
    }

    .nps-feature-analytics__actions {
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    .nps-feature-analytics__date-row {
      grid-template-columns: 1fr;
    }

    .nps-feature-analytics__iframe {
      min-height: 3000px;
    }
  }
}
</style>